import Vue from 'vue'
import VueRouter from 'vue-router'
import firebase from 'firebase'
import { Message, Loading } from 'element-ui'

Vue.use(VueRouter)

const routes = [

  /* ===================== GUEST ===================== */
  {
    path: '/',
    component: () => import('../layouts/guest-page'),
    children: [
      {
        path: '',
        name: 'login',
        component: () => import('../views/auth/loginTicket')
      }
    ]
  },

  /* ===================== AGILITÉ ===================== */
  {
    path: '/',
    component: () => import('../layouts/default-agilite-page'),
    meta: { requiresAuth: true },
    children: [

      {
        path: 'agilite/espaces/:idUser',
        name: 'agilite-espaces',
        component: () => import('../views/bp/agile/espaces')
      },

      {
        path: 'agilite/activites',
        name: 'agilite-activites',
        component: () => import('../views/bp/agile/activites')
      },

      {
        path: 'agilite/global-parametre-agilite',
        name: 'global-parametre-agilite',
        component: () => import('../views/bp/agile/global-parametre-agilite'),
        beforeEnter: accessParams,
        children: [

          {
            path: '/global-parametre/organisation',
            name: 'organisation',
            component: () => import('../views/bp/agile/global-parametre/organisation')
          },
          {
            path: 'user-global-params',
            name: 'user-global-params',
            component: () => import('../views/bp/agile/global-parametre/user-global-params')
          },
          {
            path: 'workflow-global-params',
            name: 'workflow-global-params',
            component: () => import('../views/bp/agile/global-parametre/workflow-global-params')
          },
          {
            path: 'articles-agilite',
            name: 'articles-agilite',
            component: () => import('../views/bp/agile/global-parametre/articles-agilite')
          },
          {
            path: 'projet-global-params',
            name: 'projet-global-params',
            component: () => import('../views/bp/agile/global-parametre/projet-global-params')
          },
          {
            path: 'priorite-global-params',
            name: 'priorite-global-params',
            component: () => import('../views/bp/agile/global-parametre/priorite-global-params')
          },
          {
            path: 'roles',
            name: 'setting-members-role',
            component: () => import('../views/admin/parametres/membres/role')
          }
        ]
      },
        {
                // meta: { windowRedirectAfter: true },
                path: '/agilite/activites/:idProjet/list-tickets/:idActivite',
                name: 'liste-tickets-activite',
                component: () => import(/* webpackChunkName: "liste-tickets-activites" */'../views/bp/agile/listTickets'),
            }, 

      {
        path: 'agilite/ticket/:idProjet/:idActivite/:idTicket',
        name: 'agilite-ticket',
        component: () => import('../views/bp/agile/ticket')
      },

      {
        path: 'agilite/profile/user',
        name: 'user-profile',
        component: () => import('../views/bp/profile/user')
      },
         {
                // meta: { windowRedirectAfter: true },
                path: 'agilite/activites/dashboard-agilite',
                component: () => import(/* webpackChunkName: "dashboard-agilite" */'../views/bp/agile/dashboard-agilite'),
                name: 'dashboard-agilite',
                // beforeEnter:VueMultiGuard([isRootUser])
          },

    ]
  },

  /* ===================== ERRORS ===================== */
  {
    path: '*',
    component: () => import('../layouts/error-page'),
    children: [
      {
        path: '*',
        component: () => import('../views/errors/page-not-found')
      }
    ]
  }
]

const router = new VueRouter({
  mode: 'history',
  routes,
  linkActiveClass: 'active'
})

/* ===================== AUTH GUARD ===================== */
router.beforeEach((to, from, next) => {

  if (!to.meta.requiresAuth) return next()

  const session = JSON.parse(localStorage.getItem('userSession'))
  if (!session) {
    return next('/')
  }

  firebase.firestore()
    .collection('users')
    .doc(session.uid)
    .get()
    .then(doc => {
      to.params.user = doc.data()
      next()
    })
    .catch(() => next('/'))
})

/* ===================== PERMISSIONS ===================== */
function accessParams(to, from, next) {
  firebase.firestore()
    .collection('users')
    .doc(JSON.parse(localStorage.getItem('userSession')).uid)
    .get()
    .then(doc => {
      if (!doc.data().adminId) {
        next()
      } else {
        Message.warning({
          dangerouslyUseHTMLString: true,
          message: `<strong>Vous n'avez pas les droits d'accès</strong>`
        })
      }
    })
}

export default router
